import { render } from "./ITablePagination.vue?vue&type=template&id=7aa7bcb6"
import script from "./ITablePagination.vue?vue&type=script&lang=js"
export * from "./ITablePagination.vue?vue&type=script&lang=js"

import "./ITablePagination.vue?vue&type=style&index=0&id=7aa7bcb6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__